<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-14 12:01:30
 * @FilePath: 
 * @Description: 限时抢购商品详情页面
-->
<template>
  <div>
    <div class="bg-white c-p-b-24">
      <g-swiper
        :images="activeInfo.goodsBanners"
        prefix="imgUrl"
        :isPadding="true"
        :cusStyle="cusStyle"
      ></g-swiper>
      <div class="flashSaleTime" v-if="fromPage == 'flash'">
        <!-- <div
        class="flashSaleTimeLeft"
        :style="{
          background: tipTitle !== '活动已结束' ? 'var(--tc)' : '#ccc',
        }"
      > -->
        <div class="flashSaleTimeLeft">
          <img src="@/assets/images/clock_white.png" alt="" />
          <p class="m-lr-10">{{ tipTitle }}</p>
          <!-- <van-tag v-if="isCanBuy" color="#fff" plain text-color="#fff"
          >限时优惠</van-tag
        > -->
        </div>
        <div
          class="flashSaleTimeRight"
          v-if="activeInfo.SaleStatusId != 2 && activeInfo.SaleStatusId != 3"
        >
          <p>{{ timeTitle }}</p>
          <van-count-down :time="activeInfo.time" />
        </div>
      </div>
      <div class="c-p-lr-30">
        <div class="c-fl-bt content-top">
          <div>
            <template v-if="fromPage !== 'point'">
              <span class="c-yang c-tc" v-if="activeInfo.GrouponPrice">￥</span>
              <span class="c-money c-p-r-10" v-if="activeInfo.GrouponPrice">{{
                activeInfo.GrouponPrice
              }}</span>
            </template>

            <span v-else>{{ activeInfo.GrouponPrice }}积分</span>
            <b class="c-sub-money" v-if="activeInfo.MarketPrice">
              <span class="">￥</span>{{ activeInfo.MarketPrice }}
              
            </b>
            <b class="c-yang c-tc" v-if="activeInfo.Money&&activeInfo.Money>0">
              <span >+ ￥{{ activeInfo.Money }}</span>
              
            </b>
            
          </div>
          <div>
            <span class="is-sale">已售{{ activeInfo.allSaleNumber }}</span>
          </div>
        </div>
        <div class="title c-f-bt c-m-b-15">
          <p>{{ activeInfo.TicketName }}</p>
          <div class="add-box" v-if="isCanBuy">
            <van-stepper
              :value="goodsNum"
              theme="round"
              button-size="22"
              min="0"
              disable-input
              :show-minus="goodsNum > 0"
              :show-input="goodsNum > 0"
              @plus="goodsNumHandler('add')"
              @minus="goodsNumHandler('minus')"
            />
            <!-- <div class="add-r">
              <div class="l" @click="goodsNumHandler('delete')">
                <g-img
                  :src="require('@/assets/images/reduce_icon.png')"
                  :size="50"
                ></g-img>
              </div>
              <div class="c">
                {{ this.goodsNum }}
              </div>
              <div class="r" @click="goodsNumHandler('add')">
                <g-img
                  :src="require('@/assets/images/add_icon_active.png')"
                  :size="50"
                ></g-img>
              </div>
            </div> -->
          </div>
        </div>
        <div class="buy_num_con">
          <p v-if="activeInfo.DrawMaxNumByOne">
            每人限购{{ activeInfo.DrawMaxNumByOne }}张
          </p>
          <p v-if="activeInfo.DrawMaxNumByOneByDay">
            每人每天限购{{ activeInfo.DrawMaxNumByOneByDay }}张
          </p>
        </div>

        <div class="c-font-24">
          <span class="m-r-16">售后</span>
          <span class="c-tc"
            >{{
              activeInfo.IsRefundAnyTime ? "支持随时退" : "不支持随时退"
            }}、{{
              activeInfo.IsOverdueRefund ? "支持过期退" : "不支持过期退"
            }}</span
          >
        </div>
      </div>
    </div>
    <g-line></g-line>
    <template
      v-if="
        fromPage !== 'point' ||
        activeInfo.GoodsType == 0 ||
        activeInfo.GoodsType == 1
      "
    >
      <div class="bg-white c-p-24">
        <p class="c-font-28 c-main-txt bold">详细信息</p>
        <div class="c-f-bt c-m-tb-20 c-font-24 c-main-txt">
          <p class="flex-s-0">
            <img
              src="@/assets/images/date-icon.png"
              class="w-32 c-m-r-8"
              style="vertical-align: -4px"
            />有效期
          </p>
          <p class="c-grey-6">
            {{ activeInfo.ExpireDateDescription }}
          </p>
        </div>
        <div
          class="c-f-bt c-m-tb-20 c-font-24 c-main-txt"
          v-if="fromPage !== 'point' || activeInfo.GoodsType == 0"
        >
          <p class="flex-s-0">
            <img
              src="@/assets/images/time-icon.png"
              style="vertical-align: -4px"
              class="w-32 c-m-r-8"
            />使用时间
          </p>
          <div class="c-grey-6 c-tr" @click="handleShowWeekdayModal">
            <span class="w-90% ellipsis-con" style="display: inline-block">{{
              activeInfo.UseTimeStr
            }}</span>

            <img
              src="@/assets/images/pullRight_new2.png"
              class="w-15 c-m-l-8"
              alt=""
            />
          </div>
        </div>
      </div>
      <g-line></g-line>
    </template>
    <div class="bg-white c-p-24" v-if="fromPage == 'group'">
      <p class="c-font-28 c-main-txt bold">正在拼团</p>
      <div
        class="c-f-bt c-m-tb-20 c-font-24 c-main-txt"
        v-for="(item, index) in groupBuyingList"
        :key="index"
      >
        <p class="flex-s-0">
          <img
            :src="item.Photo"
            class="w-64 c-m-r-8 c-b-r%-50"
            style="vertical-align: -11px"
          />{{ item.Name }}
        </p>
        <p class="c-grey-6 c-fl">
          <span class="c-m-r-8"
            >还差 <i class="c-tc">{{ item.People }}</i> 人成团</span
          >
          <van-button color="var(--tc)" size="mini" @click="immediatelyBuy"
            >去参团</van-button
          >
        </p>
      </div>
    </div>
    <g-line></g-line>

    <goods-img-com
      v-if="
        fromPage !== 'point' ||
        activeInfo.GoodsType == 0 ||
        activeInfo.GoodsType == 2
      "
      :textInduction="activeInfo.Introduction"
    ></goods-img-com>
    <!-- <van-goods-action v-if="fromPage == 'buy'">
      
      <van-goods-action-icon
        icon="cart-o"
        text="购物车"
        :badge="badgeNum"
        @click="shoppingCard"
      />
      <van-goods-action-button
        color="#DCC494"
        text="加入购物车"
        @click="addShoppingCard"
      />
      <van-goods-action-button
        :color="$store.state.tc"
        @click="immediatelyBuy"
        text="立即购买"
      />
    </van-goods-action> -->
    <div class="footer">
      <template v-if="fromPage == 'point'">
        <div class="c-tc font-34">
          <span>{{ allPrice }}积分</span>
          <span v-if="activeInfo.Money&&activeInfo.Money>0"> ¥ {{allMoney}}</span>
          
        </div>
        <van-button
          :disabled="goodsNum == 0 || !isCanBuy"
          color="var(--tc)"
          round
          @click="immediatelyBuy"
          >立即兑换</van-button
        >
      </template>
      <template v-if="fromPage == 'flash' || fromPage == 'buy'">
        <div class="c-tc font-34">
          <span>￥{{ allPrice }}</span>
        </div>
        <van-button
          :disabled="goodsNum == 0 || !isCanBuy"
          color="var(--tc)"
          round
          @click="immediatelyBuy"
          >立即抢购</van-button
        >
      </template>
      <template v-if="fromPage == 'group'"
        ><div class="font-34">
          <van-icon name="star-o" />
          <span class="m-l-5">收藏</span>
        </div>
        <div>
          <van-button
            :disabled="!isCanBuy"
            color="#d5b28f99"
            round
            @click="immediatelyBuy"
            style="margin-right: 10px; font-size: 15px !important"
          >
            <p>￥{{ allOriginPrice }}</p>
            <p>直接购买</p>
          </van-button>
          <van-button
            :disabled="!isCanBuy"
            color="var(--tc)"
            round
            @click="immediatelyBuy"
            style="font-size: 15px !important"
          >
            <p>￥{{ allPrice }}</p>
            <p>发起拼单</p></van-button
          >
        </div>
      </template>
    </div>
    <van-dialog
      title="使用时间"
      v-model="showDateDialog"
      show-cancel-button
      cancelButtonText="关闭"
      :show-confirm-button="false"
      @close="showDateDialog = false"
    >
      <div class="p-26 c-fc-center">
        <p style="line-height: 30px">{{ activeInfo.UseTimeStr }}</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  getGetCouponInfo,
  takeCoupon,
  getFlashRequestId,
  submitFlashOrder,
  getFlashOrderResult,
  secondSubmitFlashOrder,
} from "@/api/activity";
import { getPointGoodsDatail, submitPointGoodsOrder } from "@/api/point";
import goodsImgCom from "@/components/goodsImgCom/newIndex.vue";
import wxConfig from "@/utils/wxConfig.js";
import { verifyWechatMember } from "@/utils/gFunc";
import { handleLocalStorage } from "@/utils";
export default {
  name: "FlashSalePage",
  props: {},
  components: {
    goodsImgCom,
  },
  data() {
    return {
      fromPage: this.$route.query.fromPage,
      // productId: "299792501",
      productId: this.$route.params.id,
      // tipTitle: "",
      timeTitle: "距离结束还剩：",
      cusStyle: {
        height: "300px",
        // width: '375px',
      },
      allOriginPrice: 0,
      goodsNum: 1,
      activeInfo: {},
      isShowEmpty: false,
      isOnSale: true,
      badgeNum: null,
      goodsCache: [],
      showDateDialog: false,
      weekDaysObj: {
        Monday: "周一",
        Tuesday: "周二",
        Wednesday: "周三",
        Thursday: "周四",
        Friday: "周五",
        Saturday: "周六",
        Sunday: "周日",
      },
      groupBuyingList: [],
      isCanClick: true,
      isSubmiting: false,
    };
  },
  computed: {
    tipTitle() {
      if (this.activeInfo.SaleStatusId == 0) {
        this.timeTitle = "距离结束还剩：";
        return "抢购进行中";
      } else if (this.activeInfo.SaleStatusId == 3) {
        return "已抢完";
      } else if (this.activeInfo.SaleStatusId == 1) {
        this.timeTitle = "距离开始还剩：";
        return "抢购未开始";
      } else if (this.activeInfo.SaleStatusId == 2) {
        return "抢购已结束";
      }
    },
    isCanBuy() {
      return this.fromPage == "buy" || this.fromPage == "point"
        ? !this.isSubmiting
        : this.activeInfo.SaleStatusId == 0 && !this.isSubmiting;
    },
    allPrice() {
      if (this.activeInfo.MarketPrice) {
        this.allOriginPrice = this.$calc.multiply(
          this.activeInfo.MarketPrice,
          this.goodsNum
        );
      }
      return this.$calc.multiply(this.activeInfo.GrouponPrice, this.goodsNum);
    },

     allMoney() {
      if (this.activeInfo.Money&&this.activeInfo.Money>0) {
        this.allOriginPrice = this.$calc.multiply(
          this.activeInfo.Money,
          this.goodsNum
        );
      }
      return this.$calc.multiply(this.activeInfo.Money, this.goodsNum);
    },
  },
  created() {
    if (this.fromPage == "flash") {
      const detailInfo = handleLocalStorage.get("flashGoodsInfo");
      this.handleSetDetailInfo(detailInfo);
      // this.handleCheckOrder();
    } else {
      this.init();
    }

    if (this.fromPage == "buy") {
      this.goodsCache = this.$pub.getS("goodsCache") || [];
      if (this.goodsCache.length > 0) {
        this.goodsCache.forEach((v) => {
          this.badgeNum += v.goodsNum;
        });
      }
    }
    if (this.fromPage == "group") {
      this.handleGetBuyingList();
    }
  },
  mounted() {},
  methods: {
    init() {
      if (this.fromPage == "point") {
        getPointGoodsDatail(this.productId).then((res) => {
          // if (res.Pager.TotalCount > 0) {

          this.handleSetPointDetailInfo(res);
          //   } else {
          //     this.isShowEmpty = true;
          //   }
        });
      } else {
        // 获取产品详情
        getGetCouponInfo({ id: this.productId }).then((res) => {
          // if (res.Pager.TotalCount > 0) {

          this.handleSetDetailInfo(res);
          //   } else {
          //     this.isShowEmpty = true;
          //   }
        });
      }
    },
    handleCheckOrder() {
      let param = {
        VpnId: this.$store.state.vpnId,
        EventsId: [this.productId],
      };

      getFlashOrderResult(param)
        .then((res) => {
          if (res && res[0]) {
            // if (res[0].OrderId) {
            //   this.sureType = true;
            //   this.orderId = res[0].OrderId;
            //   this.$store.commit("setStoreVal", { orderId: res[0].OrderId });
            // } else if (res[0].Error) {
            //   this.$toast(res[0].Error);
            // }
          } else {
            // this.isCanBuy = true;
          }
        })
        .catch((err) => {});
    },
    // 积分商城商品详情赋值
    handleSetPointDetailInfo(res) {
      const data = res;
      // 产品图片
      if (res.PictureUrl) {
        data.goodsBanners = [{ imgUrl: res.PictureUrl }];
      }
      // data.TicketId = ticketItem.TicketId;
      // data.SaleStatusId = ticketItem.SaleStatusId;
      data.TicketName = data.GoodsName;
      data.GrouponPrice = data.Integral;
      // data.MarketPrice = data.MarketPrice;
      data.Introduction = data.Description;
      data.DrawMaxNumByOne = data.PersonLimit;
      data.DrawMaxNumByOneByDay = data.PersonDayLimit;
      data.ExpireDateDescription = data.ExpireDateDescription;
      data.MinBuyCount = 1; //起购数量
      this.goodsNum = 1;
      data.StepBuyCount = 1; //购买步长
      let dateStr = "";
      if (data.WeekDays && data.WeekDays.length > 0) {
        const weekArr = data.WeekDays.split(",");
        const weekChnArr = weekArr.map((wItem) => this.weekDaysObj[wItem]);
        dateStr = weekChnArr.join("，");
      }
      if (data.CanUseAllDay) {
        dateStr += " 全天可用";
      } else {
        dateStr += data.UseStartTime + "~" + data.UseEndTime;
      }
      data.UseTimeStr = dateStr;
      data.allSaleNumber = data.SaleCount || 0;
      this.activeInfo = data;
      this.activeInfo.GrouponPrice = data.Integral;
    },
    handleSetDetailInfo(res) {
      const data = res;
      // 产品简介
      // data.shortIntros = []
      // 产品图片
      data.goodsBanners = [];

      // const imgArr = data.Claims;
      const ticketItem = data.DrawTicketItems && data.DrawTicketItems[0];
      // 产品列表图片
      const imgArr = ticketItem.Claims;
      if (imgArr instanceof Array && imgArr.length > 0) {
        imgArr.map((item) => {
          if (item.TypeId === 0) {
            data.goodsImgUrl = `${item.CdnUrl}/${item.Value}`;
          }
          if (item.TypeId === 1) {
            data.goodsBanners.push({
              imgUrl: `${item.CdnUrl}/${item.Value}`,
            });
          }
        });
      }
      data.TicketId = ticketItem.TicketId;
      data.SaleStatusId = ticketItem.SaleStatusId;
      data.TicketName = ticketItem.TicketName;
      data.GrouponPrice = ticketItem.GrouponPrice;
      data.MarketPrice = ticketItem.MarketPrice;
      data.Introduction = ticketItem.Introduction;
      data.DrawMaxNumByOne = ticketItem.DrawMaxNumByOne;
      data.DrawMaxNumByOneByDay = ticketItem.DrawMaxNumByOneByDay;
      data.ExpireDateDescription = ticketItem.ExpireDateDescription;
      data.MinBuyCount = ticketItem.MinBuyCount; //起购数量
      this.goodsNum = ticketItem.MinBuyCount || 1;
      data.StepBuyCount = ticketItem.StepBuyCount; //购买步长
      let dateStr = "";
      if (ticketItem.WeekDays && ticketItem.WeekDays.length > 0) {
        const weekArr = ticketItem.WeekDays.split(",");
        const weekChnArr = weekArr.map((wItem) => this.weekDaysObj[wItem]);
        dateStr = weekChnArr.join("，");
      }
      if (ticketItem.CanUseAllDay) {
        dateStr += " 全天可用";
      } else {
        dateStr += ticketItem.UseStartTime + "~" + ticketItem.UseEndTime;
      }
      data.UseTimeStr = dateStr;

      const realSaleNumber = ticketItem.AddupStock - ticketItem.RealtimeStock;
      data.allSaleNumber = realSaleNumber + ticketItem.VirtualSaleNumber || 0;
      // 产品有效期
      // if (data.IsAbsoluteExpirationDate) {
      //   // 绝对日期
      //   data.goodsValidTime = `${data.ExpirationStartDate}至${data.ExpirationEndDate}`;
      // } else {
      //   // 相对日期
      //   data.goodsValidTime = `自购买日起${data.ExpirationDays}天内有效`;
      // }
      // // 产品的销售日期
      // this.isOnSale = isDuringDate(
      //   data.SaleStartDate || "1990-1-1",
      //   data.SaleEndDate || "2099-12-31"
      // );
      // data.SalesTime = `${data.SaleStartDate}至${data.SaleEndDate}`;
      // // 产品优惠金额
      // if (data.MarketPrice > data.CostPrice) {
      //   // data.discountAmount = (data.MarketPrice - data.CostPrice).toFixed(2)
      // }
      if (this.fromPage == "flash") {
        // this.tipTitle = data.StatusMsg;
        if (data.SaleStatusId == 1) {
          let timeNum =
            new Date(data.StartTime.replace(/-/g, "/")) - new Date();

          data.time = timeNum;
        } else if (data.SaleStatusId == 0) {
          let timeNum = new Date(data.EndTime.replace(/-/g, "/")) - new Date();

          data.time = timeNum;
        }
      }
      if (data.EnableShare) {
        // 活动分享图
        let shareImgUrl = "";
        if (res.Claims.length > 0) {
          const imgItem = res.Claims.find((element) => element.TypeId == 3);
          if (imgItem) {
            shareImgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
          }
        }
        var _this = this;
        //   // 分享图
        wxConfig.WeChatShare(
          _this,
          location.href,
          data.ShareTitle,
          shareImgUrl,
          data.ShareText
        );
      }
      this.activeInfo = data;
    },
    handleShowWeekdayModal() {
      this.showDateDialog = true;
    },
    handleGetBuyingList() {
      this.groupBuyingList = [
        {
          Name: "张三",
          Photo: require("@/assets/images/date-icon.png"),
          People: 1,
        },
        {
          Name: "李四",
          Photo: require("@/assets/images/date-icon.png"),
          People: 2,
        },
      ];
    },
    immediatelyBuy() {
      if (this.activeInfo.MustWeMember) {
        this.handleVerifyWechatMember();
      } else {
        this.submitGetRequest();
      }
    },
    async submitGetRequest() {
      if (this.isSubmiting) {
        this.$toast("正在请求中，请稍后");

        return;
      }
      if (!this.isCanClick) {
        this.$toast("操作太频繁，请稍后");

        return;
      }
      this.isSubmiting = true;
      this.isCanClick = false;
      setTimeout(() => {
        this.isCanClick = true;
      }, 3000);
      let params = {
        EventId: this.productId,
        EventClientId: 0, //活动终端类型，0:H5 1:小程序
        ProductId: this.activeInfo.TicketId,
        Quantity: this.goodsNum,
      };
      if (this.fromPage == "flash") {
        //抢购

        // getFlashRequestId().then((res) => {
        //   params.SequenceId = res;
        params.VpnId = this.$store.state.vpnId;
        submitFlashOrder(params).then((res) => {
          secondSubmitFlashOrder({ id: res }).then((res2) => {
            this.isSubmiting = false;
            const detailInfo = {
              EventId: this.productId,
              TicketId: this.activeInfo.TicketId,
              TicketName: this.activeInfo.TicketName,
              GrouponPrice: this.activeInfo.GrouponPrice,
              goodsNum: this.goodsNum,
              // preExpireTime:
            };
            handleLocalStorage.set("preOrderDetail", detailInfo);
            this.$router.push({
              name: "PreOrderInfo",
            });
          });
        });
        // });
      } else if (this.fromPage == "point") {

       this.$router.push({
        name: "pointOrderPay",
        params: { id: this.productId,goodsNum:this.goodsNum},
        query: {
          fromPage: "buy",
        },
      });

        // const pointData = handleLocalStorage.get("pointData");
        // if (pointData && pointData.memberPoint < this.allPrice) {
        //   this.isSubmiting = false;
        //   this.$toast("积分不足，无法兑换");
        //   return;
        // }
        // params = {
        //   MemberId: pointData.memberAccountId,
        //   IntegralMallGoodsId: this.productId,
        //   Number: this.goodsNum,
        //   EventClientId: 0, //活动终端类型，0:H5 1:小程序
        // };
        // submitPointGoodsOrder(params)
        //   .then((res) => {
        //     this.isSubmiting = false;
        //     // this.$store.commit("setStoreVal", { orderId: res });
        //     // handleLocalStorage.set("orderId", res);

        //     // this.$router.push({
        //     //   name: "PayList",
        //     //   query: { id: res, fromPage: "point" },
        //     // });
        //     this.$toast("兑换成功！");
        //     setTimeout(() => {
        //       this.$router.replace({ name: "PointHistoryPage" });
        //     }, 1500);
        //   })
        //   .catch(() => {
        //     this.isSubmiting = false;
        //   });
      } else {
        takeCoupon(params).then((res) => {
          this.isSubmiting = false;
          this.$store.commit("setStoreVal", { orderId: res });
          this.$router.push({
            name: "PayList",
            query: { id: res, fromPage: "goodsmall" },
          });
        });
      }
    },
    handleVerifyWechatMember() {
      verifyWechatMember(() => {
        this.submitGetRequest();
      });
    },
    // async onSubmit() {
    //   this.$pub.setS("pageBeforeLogin", "submitOrder");
    //   this.goodsInfo = this.$pub.getS("goodsInfo");
    //   const requestParams = {
    //     Phone: this.$pub.getS("userPhone") || this.$store.state.OpenId,
    //     VpnId: this.$store.state.vpnId,
    //     Items: [
    //       {
    //         DistributorId: localStorage.getItem("distributorId"),
    //         ProductId: this.goodsInfo.id,
    //         Quantity: this.goodsInfo.number,
    //       },
    //     ],
    //   };
    //   const orderId = await submitOrder(requestParams);
    //   this.$store.commit("setStoreVal", { orderId: orderId });
    //   this.$router.push({
    //     name: "PayList",
    //     query: { id: orderId, fromPage: "goodsmall" },
    //   });
    // },

    // goodsNumHandler(handle, v, i) {
    //   if (handle === "add") {
    //     this.goodsNum++;
    //   }
    //   if (handle === "delete") {
    //     if (this.goodsNum === 1) {
    //       return this.$toast("购买数量不得低于1张");
    //     }
    //     this.goodsNum--;
    //   }
    // },
    goodsNumHandler(type) {
      if (type == "add") {
        // const stepNum=item.num?item.StepNum:item.MinNum
        const stepNum = this.goodsNum
          ? this.activeInfo.StepBuyCount
          : this.activeInfo.MinBuyCount
          ? this.activeInfo.MinBuyCount
          : 1;
        this.goodsNum += stepNum;
      } else {
        // 减少数量时 若所剩余数量少于每次需要减少的步数，则只减少当前苏剩余数量
        // const stepNum=item.num-item.StepNum<0?item.num:item.StepNum
        const stepNum =
          !this.activeInfo.MinBuyCount ||
          this.goodsNum - this.activeInfo.MinBuyCount > 0
            ? this.activeInfo.StepBuyCount
            : this.activeInfo.MinBuyCount;
        this.goodsNum -= stepNum;
      }
    },
    shoppingCard() {
      this.$router.push("/goods/shoppingCard");
    },
    addShoppingCard() {
      this.badgeNum += this.goodsNum;
      this.pushGoodsCache();
    },
    pushGoodsCache() {
      let obj = this.$pub.deepClone(this.info);
      obj.goodsNum = this.goodsNum;
      if (this.goodsCache.length === 0) {
        this.goodsCache.push(obj);
      } else {
        let findIdx = this.goodsCache.findIndex((v, i) => {
          return v.Id === this.info.Id;
        });
        if (findIdx === -1) {
          this.goodsCache.push(obj);
        } else {
          this.goodsCache[findIdx].goodsNum += this.goodsNum;
        }
      }
      this.$pub.setS("goodsCache", this.goodsCache, true);
    },
  },
};
</script>
<style scoped lang="scss">
.flashSaleTime {
  display: flex;
  justify-content: space-between;
  height: 72px;

  border-radius: 0px 0px 12px 12px;
  background: linear-gradient(90deg, #c29263 0%, #e5c9ab 100%);
  color: #fff;
  position: absolute;
  top: 330px;
  left: 30px;
  right: 30px;
  padding: 0 20px;
  font-size: 24px;
  .flashSaleTimeLeft {
    flex: 1;

    display: flex;
    align-items: center;
    img {
      width: 35px;
    }
    // .van-tag--plain {
    //   background: transparent;
    // }
  }
  .flashSaleTimeRight {
    display: flex;
    justify-content: center;
    align-items: center;
    .van-count-down {
      font-size: 13px;
      color: #fff;
    }
  }
}
.sale-price {
  font-size: 48px;
  font-weight: bold;
  font-family: Cochin-Bold, Cochin;
  color: var(--tc);
  margin-right: 10px;
}
.yang {
  color: var(--tc);
}
.is-sale {
  font-size: 24px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #888888;
}
.content-top {
  margin-bottom: 15px;
}
.title {
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.buy_num_con {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  p {
    border-radius: 8px;
    border: 1px solid rgba(108, 60, 20, 0.5);
    padding: 5px 10px;
    color: #76461f;
    margin-right: 10px;
    font-size: 24px;
  }
}
.add-box {
  flex-shrink: 0;
  display: flex;
  flex-direction: row-reverse;
  .add-r {
    width: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .c {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
}
.list {
  box-sizing: border-box;
  font-size: 26px;
  & > div {
    margin: 10px 0;
  }
  .l-l {
    font-weight: 400;
    color: #888888;
    margin-right: 20px;
  }
  .l-r {
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  height: 130px;
  border-top: 1px solid #eee;
  background: #fff;
  box-sizing: border-box;
  padding: 0 32px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}
</style>
